import { Configuration, RedirectRequest } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_AD_TENANT_ID || '';

// Custom API scope exposed by our backend app registration. This is what the backend
// validates as `aud`. Falls back to the standard pattern if the env var is unset.
const apiScope =
  process.env.REACT_APP_AZURE_AD_API_SCOPE ||
  (clientId ? `api://${clientId}/access_as_user` : '');

export const isAzureAdConfigured = Boolean(clientId);

const redirectUri =
  process.env.REACT_APP_AZURE_AD_REDIRECT_URI || window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Sign-in uses standard OIDC scopes only. The custom api:// scope is requested
// separately when calling our backend — requesting it at login fails if the app
// registration has not exposed that API (AADSTS500011).
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Include profile/email so the API access token carries display name and email claims.
export const apiTokenRequest: RedirectRequest = {
  scopes: apiScope
    ? [apiScope, 'profile', 'email']
    : ['openid', 'profile', 'email'],
};
